export const PGA_HOPE_GROUP_EVENT_TAG = 'PGA HOPE'

export const coachHasGroupEventTypeBesidesPgaHope = groupEventTemplates => {
  if (!groupEventTemplates?.length) {
    return false
  }

  return groupEventTemplates.some(
    template => !(template.tags || []).includes(PGA_HOPE_GROUP_EVENT_TAG),
  )
}

export const coachHasPgaHopeGroupEventTemplate = groupEventTemplates => {
  if (!groupEventTemplates?.length) {
    return false
  }

  return groupEventTemplates.some(template =>
    (template.tags || []).includes(PGA_HOPE_GROUP_EVENT_TAG),
  )
}

export const shouldUseHopeAdmPromotionCopy = groupEventTemplates =>
  coachHasPgaHopeGroupEventTemplate(groupEventTemplates) &&
  coachHasGroupEventTypeBesidesPgaHope(groupEventTemplates)

export const shouldShowGroupEventsAdmPromotionTip = ({
  canPromoteContent,
  groupEventTemplates,
  showEmptyState,
  templatesLoading,
  templatesError,
}) => {
  if (canPromoteContent || showEmptyState || templatesLoading) {
    return false
  }

  if (templatesError) {
    return true
  }

  return coachHasGroupEventTypeBesidesPgaHope(groupEventTemplates)
}
